import { AuthData, useAuth } from 'contexts/auth';
import { Role } from 'types/domainModels';
import { useGlobalStore } from './store';

// old feature flag code, refactor when we have proper auth0 roles
export const DEVELOPER_EMAILS = [
  'travis.demint@useglass.com',
  'ron.thompson@useglass.com',
  'ron.thompson+nonadmin@useglass.com',
];

export function useHasRole(role: Role): boolean {
  const { data } = useAuth();
  return data?.role ? role === data?.role : false;
}

export function useHasOrganization(orgId: number): boolean {
  const { data } = useAuth();
  return data?.organizationId ? orgId === data?.organizationId : false;
}

function isAuthorizedDeveloper(data: AuthData | null): boolean {
  if (!data?.email) {
    return false;
  }
  return DEVELOPER_EMAILS.includes(data.email.toLowerCase());
}
// end old code

export enum FeatureFlagName {
  QUOTE_TOOL_NEW = 'quote_tool_new',
}

export const useFeatureFlag = (flagName: string) => {
  const { data } = useAuth();
  const isAdmin = useHasRole('admin');
  const isDeveloper = isAuthorizedDeveloper(data);

  const allFlags = useGlobalStore((store) => store.flags);
  const specificFlag = allFlags.find((flag) => flag.name === flagName);
  if (!specificFlag) {
    return false;
  }
  if (isDeveloper) {
    return specificFlag.isEnabledDev;
  }
  if (isAdmin) {
    return specificFlag.isEnabledAdmin;
  }
  return specificFlag.isEnabled;
};
